module.exports = __webpack_public_path__ + "static/media/7sharp.cdc8d08b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/AsSeenOnTV/brands/7sharp.png
// module id = 576
// module chunks = 0